function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 23.47c6.32 0 11.46-5.14 11.46-11.46C23.46 5.69 18.32.55 12 .55 5.68.55.54 5.69.54 12.01c0 6.32 5.14 11.46 11.46 11.46zm.6-17.27v7.33c0 .33-.27.6-.6.6-.33 0-.6-.27-.6-.6V6.2c0-.33.27-.6.6-.6.33 0 .6.27.6.6zm-.6 9.94c.46 0 .83.37.83.83 0 .46-.37.83-.83.83-.46 0-.83-.37-.83-.83 0-.46.37-.83.83-.83z",
  fill: "#7F63FF"
});

function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "b6bb383c14689778b5b8b9c8fa65f686.svg";
export { SvgAttention as ReactComponent };